import React from "react";
const IntroductionComponent = () => {
  return (
    <>
      <p className="title">もなかとは</p>
      <p>あなたの趣味に合う方を探して</p>
      <p>コミュニケーションをとってみましょう！</p>
      <p>あなた好みの料理に出会えるかもしれません！</p>
    </>
  );
};
export default IntroductionComponent;